// Get text width
export function getTextWidth(text, font) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const padding = 40; // DataGrid left/right padding

  context.font = font || getComputedStyle(document.body).font;

  return context.measureText(text).width + padding;
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
}

export function formatDate(value) {
  return new Date(value).toISOString().split('T')[0];
}

export function formatPorcentage(value) {
  return `${value}%`;
}

export function objectsShallowEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
}